import { jwtDecode } from "jwt-decode";

// Dynamically use the current domain the UI is served from
const apiUrl = `${window.location.protocol}//${window.location.hostname}`;

const authProvider = {
    login: ({ username, password }) => {
        console.log('API URL:', apiUrl);
        const request = new Request(`${apiUrl}/api/login`, {
            method: 'POST',
            body: JSON.stringify({ username, password }),
            headers: new Headers({ 'Content-Type': 'application/json' }),
        });
        return fetch(request)
            .then(response => {
                if (response.status < 200 || response.status >= 300) {
                    throw new Error(response.statusText);
                }
                return response.json();
            })
            .then(({ token }) => {
                const decodedToken = jwtDecode(token);
                console.log('Decoded token:', decodedToken);
                localStorage.setItem('token', token);
                // Store isAdmin flag for permission checks (check both camelCase and snake_case)
                // Use more robust truthy check: convert to boolean explicitly
                const isAdminValue = decodedToken.isAdmin !== undefined ? decodedToken.isAdmin : decodedToken.is_admin;
                const isAdmin = Boolean(isAdminValue);
                console.log('isAdmin raw value:', isAdminValue, 'converted to:', isAdmin);
                const permissions = {
                    role: decodedToken.permissions,
                    isAdmin: isAdmin
                };
                console.log('Storing permissions:', permissions);
                localStorage.setItem('permissions', JSON.stringify(permissions));
            });
    },
    logout: () => {
        localStorage.removeItem('token');
        localStorage.removeItem('permissions');
        return Promise.resolve();
    },
    checkError: error => {
        const status = error.status;
        if (status === 401 || status === 403) {
            localStorage.removeItem('token');
            localStorage.removeItem('permissions');
            return Promise.reject({ redirectTo: '/login' });
        }
        // other error code (404, 500, etc): no need to log out
        return Promise.resolve();
    },
    checkAuth: () => localStorage.getItem('token')
        ? Promise.resolve()
        : Promise.reject({ redirectTo: '/login' }),
    getPermissions: () => {
        const permissionsStr = localStorage.getItem('permissions');
        console.log('getPermissions called, raw value:', permissionsStr);
        if (!permissionsStr) {
            console.log('No permissions found in localStorage');
            return Promise.reject();
        }
        try {
            const permissions = JSON.parse(permissionsStr);
            console.log('Parsed permissions:', permissions);
            return Promise.resolve(permissions);
        } catch (e) {
            // Fallback for old format (just a string)
            console.log('Using fallback permissions format');
            return Promise.resolve({ role: permissionsStr, isAdmin: false });
        }
    }
};

export default authProvider;
